import Echo from "laravel-echo";
import "pusher-js";
import { getPusherConfig, getApiConfig } from "@/config";

/**
 * @param {import("vuex").Store} store
 */
export const makeEchoPlugin = store => {
  return {
    install(vue) {
      const pusherConfig = getPusherConfig();
      const apiConfig = getApiConfig();

      const EchoManager = new Echo({
        broadcaster: "pusher",
        key: pusherConfig.appKey,
        cluster: pusherConfig.cluster,
        wsHost: pusherConfig.host,
        wsPort: pusherConfig.port,
        wssPort: pusherConfig.port,
        forceTLS: false,
        encrypted: true,
        disableStats: true,
        enabledTransports: ["ws", "wss"],
        authEndpoint: apiConfig.host + "/broadcasting/auth",
        auth: {
          headers: {
            // Authorization: `Bearer ${authStore.accessToken}`,
          },
        },
      });
      EchoManager.connector.pusher.connection.bind("state_change", function(states) {
        store.commit("setSocketStatus", states.current);
      });
      if (store.state.auth.accessToken) {
        EchoManager.connector.options.auth.headers.Authorization = store.state.auth.accessToken;
      }

      store.watch(
        state => {
          return state.auth.accessToken;
        },
        newToken => {
          if (newToken) {
            EchoManager.connector.options.auth.headers.Authorization = newToken;
            EchoManager.connect();
            return;
          }

          EchoManager.disconnect();
        },
        {
          deep: true,
        },
      );

      vue.prototype.$echo = EchoManager;
    },
  };
};
